import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTrustMarkerWidgetStyles = markerUrlSize => {
  return StyleSheet.create({
    container: {
      flexDirection: 'column',
      alignItems: 'center'
    },
    topImage: {
      marginBottom: tokens.spacing.SPACING_4
    },
    contentContainer: {
      flexDirection: 'column',
      alignItems: 'center'
    },
    subHeadingContainer: {
      flexDirection: 'row',
      marginTop: tokens.spacing.SPACING_4,
      alignItems: 'center'
    },
    subHeadingImageUrl: {
      marginLeft: tokens.spacing.SPACING_4
    },
    markerUrlsContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      margin: -tokens.spacing.SPACING_4,
      marginTop: markerUrlSize == 'sm' ? tokens.spacing.SPACING_4 : tokens.spacing.SPACING_8
    },
    singleMarkerUrl: {
      margin: tokens.spacing.SPACING_4
    }
  });
};
export var getMarkerImageWidth = (markerUrlSize, isLargeScreen) => {
  switch (markerUrlSize) {
    case 'sm':
      return isLargeScreen ? 32 : 24;
    case 'lg':
      return 120;
    default:
      return 60;
  }
};
export var getMarkerImageHeight = (markerUrlSize, isLargeScreen) => {
  switch (markerUrlSize) {
    case 'sm':
      return isLargeScreen ? 32 : 24;
    case 'lg':
      return 100;
    default:
      return 40;
  }
};